import GiftGuidePage from './gift_guide_page';
import giftGuidePageStateManager from './gift_guide_page_state_manager';

export default function(store) {
  return {
    path: '/gift-guide/:slug/category/:category',
    component: GiftGuidePage,
    exact: true,
    strict: true,
    loadData: giftGuidePageStateManager(store),
    autoScrollOff: true
  };
}
